export default __webpack_public_path__ + "static/media/Successfullyregister.7e13bfdd.png";